// Create control band at the bottom of the screen

const formatDate = (date) => {
  if (!date) return '';
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const createControlBand = (key, showTagMap, showSelection, show_full_orbits, show_chl, show_sla, 
                                  show_wind_arrows, show_satellite_view, show_orbit_labels, 
                                  show_split_color_spectrum, exclude_edges, show_clouds = false,
                                  mark_iffy_points = false, show_current_arrows = false, show_land_points = false, show_oco2 = true, show_oco3 = true, show_vorticity = false, show_grid_wind_arrows = false, show_socat = false, show_bga = false, show_peaks = false, show_valleys = false, use_iffy_filter_files = false, show_mblh = false) => {
  const band = document.createElement('div');
  band.id = 'control-band';
  band.className = 'control-band';

  const grid = document.createElement('div');
  grid.className = 'control-band-grid';

  const varValues = {
    show_chl,
    show_sla,
    show_wind_arrows,
    show_satellite_view,
    show_orbit_labels,
    show_split_color_spectrum,
    exclude_edges,
    show_clouds,
    mark_iffy_points,
    show_current_arrows,
    show_land_points,
    show_oco2,
    show_oco3,
    show_vorticity,
    show_grid_wind_arrows,
    show_socat,
    show_bga,
    show_mblh,
    show_peaks,
    show_valleys,
    use_iffy_filter_files
  };

  const makeColumn = (extra_class) => {
    const col = document.createElement('div');
    if (extra_class) {
      col.className = `control-col ${extra_class}`;
    } else {
      col.className = 'control-col';
    }
    return col;
  };

  const createCheckbox = (cb) => {
    const checkboxWrapper = document.createElement('label');
    checkboxWrapper.className = 'control-checkbox';

    const tooltip = cb.tooltip || cb.label;
    const checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.id = cb.id;
    checkbox.checked = Boolean(varValues[cb.variable]);
    checkbox.title = tooltip;
    if (cb.disabled) {
      checkbox.disabled = true;
    }

    const text = document.createElement('span');
    text.textContent = cb.label;
    text.title = tooltip;
    checkboxWrapper.title = tooltip;

    checkboxWrapper.appendChild(checkbox);
    checkboxWrapper.appendChild(text);
    return checkboxWrapper;
  };

  // Column 1: primary selectors and date/window controls.
  const column1 = makeColumn();
  column1.classList.add('control-col-wide');

  const topRow = document.createElement('div');
  topRow.className = 'control-top-row';

  const showContainer = document.createElement('div');
  showContainer.className = 'control-inline-field';
  const showLabel = document.createElement('label');
  showLabel.textContent = 'Show:';
  showLabel.htmlFor = 'show-dropdown';
  const showDropdown = document.createElement('select');
  showDropdown.id = 'show-dropdown';

  Object.keys(showTagMap).forEach(label => {
    const option = document.createElement('option');
    option.value = showTagMap[label];
    option.textContent = label;
    if (showTagMap[label] === showSelection) option.selected = true;
    showDropdown.appendChild(option);
  });
  showContainer.appendChild(showLabel);
  showContainer.appendChild(showDropdown);

  const locationContainer = document.createElement('div');
  locationContainer.className = 'control-inline-field';
  const locationLabel = document.createElement('label');
  locationLabel.textContent = 'Location:';
  locationLabel.htmlFor = 'location-dropdown';
  const locationDropdown = document.createElement('select');
  locationDropdown.id = 'location-dropdown';
  const defaultOption = document.createElement('option');
  defaultOption.value = 'Ahyi_Seamount_2022_07';
  defaultOption.textContent = 'Ahyi_Seamount_2022_07';
  defaultOption.selected = true;
  locationDropdown.appendChild(defaultOption);
  locationContainer.appendChild(locationLabel);
  locationContainer.appendChild(locationDropdown);

  const loadButton = document.createElement('button');
  loadButton.id = 'load-data-button';
  loadButton.textContent = 'Load';
  loadButton.className = 'control-load-button';

  topRow.appendChild(showContainer);
  topRow.appendChild(locationContainer);
  topRow.appendChild(loadButton);

  const dateWindowBox = document.createElement('div');
  dateWindowBox.className = 'date-window-box';

  const dateRangeGroup = document.createElement('div');
  dateRangeGroup.className = 'control-slider-group';
  const dateRangeHeader = document.createElement('div');
  dateRangeHeader.className = 'control-slider-title';
  dateRangeHeader.textContent = 'Date range';

  const dateRangeSlider = document.createElement('input');
  dateRangeSlider.type = 'range';
  dateRangeSlider.min = '0';
  dateRangeSlider.max = '0';
  dateRangeSlider.step = '1';
  dateRangeSlider.value = '0';
  dateRangeSlider.disabled = true;
  dateRangeSlider.className = 'slider';
  dateRangeSlider.id = 'date-range-slider';

  const dateRangeLabels = document.createElement('div');
  dateRangeLabels.className = 'control-date-labels';
  const dateRangeStartLabel = document.createElement('span');
  dateRangeStartLabel.textContent = '—';
  const dateRangeEndLabel = document.createElement('span');
  dateRangeEndLabel.textContent = '—';
  const dateRangeValue = document.createElement('div');
  dateRangeValue.className = 'control-date-current';
  dateRangeValue.textContent = 'No data';

  dateRangeLabels.appendChild(dateRangeStartLabel);
  dateRangeLabels.appendChild(dateRangeValue);
  dateRangeLabels.appendChild(dateRangeEndLabel);

  dateRangeGroup.appendChild(dateRangeHeader);
  dateRangeGroup.appendChild(dateRangeSlider);
  dateRangeGroup.appendChild(dateRangeLabels);

  const windowGroup = document.createElement('div');
  windowGroup.className = 'control-slider-group';
  const windowHeader = document.createElement('div');
  windowHeader.className = 'control-slider-title';
  windowHeader.textContent = 'Window size';

  const windowSizeSlider = document.createElement('input');
  windowSizeSlider.type = 'range';
  windowSizeSlider.min = '1';
  windowSizeSlider.max = '30';
  windowSizeSlider.step = '1';
  windowSizeSlider.value = '14';
  windowSizeSlider.className = 'slider';

  const windowSizeValue = document.createElement('div');
  windowSizeValue.className = 'control-date-current';
  windowSizeValue.textContent = '14 days';

  windowGroup.appendChild(windowHeader);
  windowGroup.appendChild(windowSizeSlider);
  windowGroup.appendChild(windowSizeValue);

  dateWindowBox.appendChild(dateRangeGroup);
  dateWindowBox.appendChild(windowGroup);

  column1.appendChild(topRow);
  column1.appendChild(dateWindowBox);

  // Column 2: existing data behavior checkboxes.
  const column2 = makeColumn("control-col-checkboxes");
  const column2Checks = [
    { id: 'wind-arrows', label: 'Wind Arrows', variable: 'show_wind_arrows', tooltip: 'Toggle OCO-based wind arrows' },
    { id: 'grid-wind-arrows', label: 'Grid Wind Arrows', variable: 'show_grid_wind_arrows', tooltip: 'Click on a data point to select the date for grid wind arrows' },
    { id: 'orbit-labels', label: 'Orbit Labels', variable: 'show_orbit_labels', tooltip: 'Display orbit path labels' },
    { id: 'split_spectrum', label: 'Split Color Spectrum', variable: 'show_split_color_spectrum', tooltip: 'Toggle the split color spectrum overlay' },
    { id: 'exclude-ends', label: 'Exclude limited avgs', variable: 'exclude_edges', tooltip: 'Hide points averaged from fewer than eight samples' },
    { id: 'land-points', label: 'Land Points', variable: 'show_land_points', tooltip: 'Show points located on land' },
    { id: 'mark-iffy-points', label: 'Mark Iffy Points', variable: 'mark_iffy_points', tooltip: 'Highlight questionable data points' },
    { id: 'iffy-filter', label: 'Iffy Filter', variable: 'use_iffy_filter_files', tooltip: 'Enable tighter filter of outlier points. This tends to make points impacted by light clouds more reliable. May be unavailable for some datasets.' }
  ];

  // Column 3: clouds and future toggles.
  const column3 = makeColumn("control-col-checkboxes");
  const column3Checks = [
    { id: 'clouds', label: 'Clouds', variable: 'show_clouds', tooltip: 'Click on a data point to select the date for clouds. The time may not match the data point time.' },
    { id: 'current-arrows', label: 'Current Arrows', variable: 'show_current_arrows', tooltip: 'Click on a data point to select the date for current arrows' },
    { id: 'chl', label: 'Chl', variable: 'show_chl', tooltip: 'Click on a data point to select the date for Chlorophyll data' },
    { id: 'vorticity', label: 'Vorticity', variable: 'show_vorticity', tooltip: 'Click on a data point to select the date for vorticity data' },
    { id: 'bga', label: 'BGA', variable: 'show_bga', tooltip: 'Show Blue-Green Algae if available' },
    { id: 'mblh', label: 'MBLH', variable: 'show_mblh', tooltip: 'Click on a data point to select the date for the Marine Boundary Layer Height' },
    { id: 'peaks', label: 'Peaks', variable: 'show_peaks', tooltip: 'Show peak values in each orbit' },
    { id: 'valleys', label: 'Valleys', variable: 'show_valleys', tooltip: 'Show minimal values in each orbit' }
  ];

  // Column 3b: data source toggles, between the Clouds checkbox column and the Value filter column.
  const column3b = makeColumn("control-col-checkboxes");
  const column3bChecks = [
    { id: 'oco2', label: 'OCO2', variable: 'show_oco2', tooltip: 'Toggle Orbiting Carbon Observatory-2 (OCO-2) data layer' },
    { id: 'oco3', label: 'OCO3', variable: 'show_oco3', tooltip: 'Toggle Orbiting Carbon Observatory-3 (OCO-3) data layer' },
    { id: 'socat', label: 'SOCAT', variable: 'show_socat', tooltip: 'Toggle Surface Ocean CO2 Atlas (SOCAT) v2026 data layer' }
  ];

  const checkboxes = [...column2Checks, ...column3Checks, ...column3bChecks];
  column2Checks.forEach(cb => column2.appendChild(createCheckbox(cb)));
  column3Checks.forEach(cb => column3.appendChild(createCheckbox(cb)));
  column3bChecks.forEach(cb => column3b.appendChild(createCheckbox(cb)));

  const measureToolButton = document.createElement('button');
  measureToolButton.id = 'measure-tool-button';
  measureToolButton.className = 'measure-tool-button';
  measureToolButton.textContent = 'Measure Tool';

  const graphToolButton = document.createElement('button');
  graphToolButton.id = 'graph-tool-button';
  graphToolButton.className = 'measure-tool-button';
  graphToolButton.textContent = 'Graph';

  const toolButtonRow = document.createElement('div');
  toolButtonRow.className = 'tool-button-row';
  toolButtonRow.appendChild(measureToolButton);
  toolButtonRow.appendChild(graphToolButton);
  column3b.appendChild(toolButtonRow);

  // Column 4: value filter slider and message area.
  const column4 = makeColumn();
  column4.classList.add('control-col-range');
  const valueRangeTitle = document.createElement('div');
  valueRangeTitle.className = 'control-slider-title';
  valueRangeTitle.textContent = 'Value filter';

  const valueRangeWrap = document.createElement('div');
  valueRangeWrap.className = 'dual-range-wrap';

  const valueRangeTrack = document.createElement('div');
  valueRangeTrack.className = 'dual-range-track';

  const valueRangeSelected = document.createElement('div');
  valueRangeSelected.className = 'dual-range-selected';

  const valueRangeMinSlider = document.createElement('input');
  valueRangeMinSlider.type = 'range';
  valueRangeMinSlider.min = '0';
  valueRangeMinSlider.max = '1000';
  valueRangeMinSlider.value = '0';
  valueRangeMinSlider.step = '1';
  valueRangeMinSlider.className = 'dual-range-input dual-range-input-min';
  valueRangeMinSlider.id = 'value-range-min';
  valueRangeMinSlider.disabled = true;

  const valueRangeMaxSlider = document.createElement('input');
  valueRangeMaxSlider.type = 'range';
  valueRangeMaxSlider.min = '0';
  valueRangeMaxSlider.max = '1000';
  valueRangeMaxSlider.value = '1000';
  valueRangeMaxSlider.step = '1';
  valueRangeMaxSlider.className = 'dual-range-input dual-range-input-max';
  valueRangeMaxSlider.id = 'value-range-max';
  valueRangeMaxSlider.disabled = true;

  const minHandleLabel = document.createElement('div');
  minHandleLabel.className = 'dual-range-handle-label';
  minHandleLabel.textContent = '—';

  const maxHandleLabel = document.createElement('div');
  maxHandleLabel.className = 'dual-range-handle-label';
  maxHandleLabel.textContent = '—';

  valueRangeWrap.appendChild(valueRangeTrack);
  valueRangeWrap.appendChild(valueRangeSelected);
  valueRangeWrap.appendChild(valueRangeMinSlider);
  valueRangeWrap.appendChild(valueRangeMaxSlider);
  valueRangeWrap.appendChild(minHandleLabel);
  valueRangeWrap.appendChild(maxHandleLabel);

  const valueRangeLine = document.createElement('div');
  valueRangeLine.className = 'value-range-line';
  const valueRangeMinLabel = document.createElement('span');
  valueRangeMinLabel.textContent = '—';
  const valueRangeMaxLabel = document.createElement('span');
  valueRangeMaxLabel.textContent = '—';
  valueRangeLine.appendChild(valueRangeMinLabel);
  valueRangeLine.appendChild(valueRangeMaxLabel);

  const messageArea = document.createElement('div');
  messageArea.id = 'message-area';
  messageArea.className = 'message-area';

  column4.appendChild(valueRangeTitle);
  column4.appendChild(valueRangeWrap);
  column4.appendChild(valueRangeLine);
  column4.appendChild(messageArea);

  // Column 5: coordinate readout.
  const column5 = makeColumn();
  // const coordTitle = document.createElement('div');
  // coordTitle.className = 'control-slider-title';
  // coordTitle.textContent = 'Cursor';

  const coordArea = document.createElement('div');
  coordArea.id = 'mouse-position-div';
  coordArea.className = 'mouse-position-area';

  const infoLink = document.createElement('a');
  infoLink.id = 'site-guide-link';
  infoLink.className = 'site-guide-link';
  infoLink.href = './SiteGuide.html';
  infoLink.target = '_blank';
  infoLink.rel = 'noopener noreferrer';
  infoLink.title = 'Open Site Guide';
  infoLink.textContent = 'Site Guide';

  
  

  const copyLocationButton = document.createElement('button');
  copyLocationButton.id = 'copy-location-button';
  copyLocationButton.className = 'copy-location-button';
  copyLocationButton.textContent = 'Copy Location';

  const copyStatusArea = document.createElement('div');
  copyStatusArea.id = 'copy-status-area';
  copyStatusArea.className = 'copy-status-area';
  copyStatusArea.textContent = '';

  // column5.appendChild(coordTitle);
    column5.appendChild(coordArea);
  column5.appendChild(copyLocationButton);
  column5.appendChild(copyStatusArea);
  column5.appendChild(infoLink);

  grid.appendChild(column1);
  grid.appendChild(column2);
  grid.appendChild(column3);
  grid.appendChild(column3b);
  grid.appendChild(column4);
  grid.appendChild(column5);
  band.appendChild(grid);
  
  document.body.appendChild(band);
  
  // Adjust map bottom margin to account for control band
  const map = document.getElementById('map');
  const syncMapBottomOffset = () => {
    if (!map) return;
    map.style.bottom = `${Math.ceil(band.getBoundingClientRect().height)}px`;
  };
  syncMapBottomOffset();
  window.addEventListener('resize', syncMapBottomOffset);

  const valueFilterState = {
    min: 0,
    max: 1000,
    selectedMin: 0,
    selectedMax: 1000,
    unit: '',
    decimals: 2,
    disabled: true
  };

  const clamp = (val, min, max) => Math.max(min, Math.min(max, val));
  const formatValue = (val, decimals, unit) => `${Number(val).toFixed(decimals)}${unit ? ` ${unit}` : ''}`;
  const parseSliderValue = (element) => Number(element.value);

  // Keep range shading and value labels synchronized with the slider handle positions.
  const updateValueRangeVisuals = () => {
    const fullRange = valueFilterState.max - valueFilterState.min;
    const selectedMin = parseSliderValue(valueRangeMinSlider);
    const selectedMax = parseSliderValue(valueRangeMaxSlider);

    const minPct = fullRange > 0 ? ((selectedMin - valueFilterState.min) / fullRange) * 100 : 0;
    const maxPct = fullRange > 0 ? ((selectedMax - valueFilterState.min) / fullRange) * 100 : 100;
    valueRangeSelected.style.left = `${minPct}%`;
    valueRangeSelected.style.width = `${Math.max(0, maxPct - minPct)}%`;

    minHandleLabel.textContent = formatValue(selectedMin, valueFilterState.decimals, valueFilterState.unit);
    maxHandleLabel.textContent = formatValue(selectedMax, valueFilterState.decimals, valueFilterState.unit);
    minHandleLabel.style.left = `${minPct + 4}%`;  // Keep label inside the slider track, adjust as needed for aesthetics
    maxHandleLabel.style.left = `${maxPct - 4}%`;

    // Keep labels readable when handles are close by vertically offsetting one label.
    minHandleLabel.style.top = '24px';
    maxHandleLabel.style.top = '24px';

    // Check for overlap and adjust max label position if necessary
    // Calculate the pixel positions of left and width of min label
    const minLabelLeft =  minHandleLabel.offsetLeft 
    const minLabelWidth = minHandleLabel.offsetWidth;
    const minLabelRight = minLabelLeft + minLabelWidth;

    // Calculate left of max label
    const maxLabelLeft = maxHandleLabel.offsetLeft; 

    const overlapPadding = 6; // Minimum padding between labels to avoid overlap
    const labelsOverlap = minLabelRight + overlapPadding >= maxLabelLeft;
    if (labelsOverlap) {
      maxHandleLabel.style.top = '34px';
    }
  };

  const updateValueRangeControls = ({min, max, selectedMin, selectedMax, unit, decimals, disabled}) => {
    valueFilterState.min = Number.isFinite(min) ? min : 0;
    valueFilterState.max = Number.isFinite(max) ? max : valueFilterState.min;
    valueFilterState.unit = unit || '';
    valueFilterState.decimals = Number.isFinite(decimals) ? decimals : 2;
    valueFilterState.disabled = Boolean(disabled);

    const sliderStep = valueFilterState.max === valueFilterState.min ? 1 : (valueFilterState.max - valueFilterState.min) / 1000;
    const safeMin = clamp(Number.isFinite(selectedMin) ? selectedMin : valueFilterState.min, valueFilterState.min, valueFilterState.max);
    const safeMax = clamp(Number.isFinite(selectedMax) ? selectedMax : valueFilterState.max, valueFilterState.min, valueFilterState.max);

    valueRangeMinSlider.min = String(valueFilterState.min);
    valueRangeMinSlider.max = String(valueFilterState.max);
    valueRangeMaxSlider.min = String(valueFilterState.min);
    valueRangeMaxSlider.max = String(valueFilterState.max);
    valueRangeMinSlider.step = String(sliderStep);
    valueRangeMaxSlider.step = String(sliderStep);
    valueRangeMinSlider.value = String(Math.min(safeMin, safeMax));
    valueRangeMaxSlider.value = String(Math.max(safeMin, safeMax));
    valueRangeMinSlider.disabled = valueFilterState.disabled;
    valueRangeMaxSlider.disabled = valueFilterState.disabled;

    valueRangeMinLabel.textContent = formatValue(valueFilterState.min, valueFilterState.decimals, valueFilterState.unit);
    valueRangeMaxLabel.textContent = formatValue(valueFilterState.max, valueFilterState.decimals, valueFilterState.unit);
    updateValueRangeVisuals();
  };

  valueRangeMinSlider.addEventListener('input', () => {
    const minVal = parseSliderValue(valueRangeMinSlider);
    const maxVal = parseSliderValue(valueRangeMaxSlider);
    if (minVal > maxVal) {
      valueRangeMinSlider.value = valueRangeMaxSlider.value;
    }
    updateValueRangeVisuals();
  });

  valueRangeMaxSlider.addEventListener('input', () => {
    const minVal = parseSliderValue(valueRangeMinSlider);
    const maxVal = parseSliderValue(valueRangeMaxSlider);
    if (maxVal < minVal) {
      valueRangeMaxSlider.value = valueRangeMinSlider.value;
    }
    updateValueRangeVisuals();
  });
  
  return {
    showDropdown,
    locationDropdown,
    checkboxes: checkboxes.map(cb => ({
      element: document.getElementById(cb.id),
      variable: cb.variable
    })),
    loadButton,
    messageArea,
    copyLocationButton,
    measureToolButton,
    graphToolButton,
    copyStatusArea,
    dateRangeSlider,
    windowSizeSlider,
    valueRangeMinSlider,
    valueRangeMaxSlider,
    getValueRangeSelection: () => ({
      min: parseSliderValue(valueRangeMinSlider),
      max: parseSliderValue(valueRangeMaxSlider)
    }),
    updateValueRangeControls,
    updateDateRangeControls: ({minDate, maxDate, startDate, endDate, windowSize, disabled}) => {
      if (!minDate || !maxDate) {
        dateRangeStartLabel.textContent = '—';
        dateRangeEndLabel.textContent = '—';
        dateRangeValue.textContent = 'No data';
        dateRangeSlider.disabled = true;
        return;
      }

      const totalSpan = Math.max(0, Math.round((maxDate - minDate) / 86400000));
      const sliderWindow = Math.max(1, Math.min(30, Number(windowSize) || 14));
      const maxStartOffset = Math.max(0, totalSpan - sliderWindow);
      const startOffset = Math.max(0, Math.min(maxStartOffset, Math.round((startDate - minDate) / 86400000)));
      const max_thumb_width = dateRangeSlider.offsetWidth; // Maximum width for the thumb in pixels
      const min_thumb_width = 20; // Minimum width for the thumb in pixels
      const thumb_width = Math.max(min_thumb_width, Math.min(max_thumb_width, (sliderWindow / totalSpan) * max_thumb_width));
      // console.log(`minDate: ${formatDate(minDate)}, maxDate: ${formatDate(maxDate)}, startDate: ${formatDate(startDate)}, 
      //        endDate: ${formatDate(endDate)}, totalSpan: ${totalSpan}, sliderWindow: ${sliderWindow}, maxStartOffset: ${maxStartOffset}, 
      //        startOffset: ${startOffset}, thumb_width: ${thumb_width}, max_thumb_width: ${max_thumb_width}, min_thumb_width: ${min_thumb_width}`);
      dateRangeStartLabel.textContent = formatDate(minDate);
      dateRangeEndLabel.textContent = formatDate(maxDate);
      dateRangeSlider.min = '0';
      dateRangeSlider.max = String(maxStartOffset);
      dateRangeSlider.value = String(startOffset);
      dateRangeSlider.disabled = disabled || totalSpan <= 0;
      windowSizeSlider.min = '1';
      // Set window slider max to the smaller of 30 or the total span of available data
      windowSizeSlider.max = Math.min(30, totalSpan).toString();
      windowSizeSlider.value = String(sliderWindow);
      dateRangeValue.textContent = `${formatDate(startDate)} → ${formatDate(endDate)}`;
      windowSizeValue.textContent = `${sliderWindow} days`;
      // Set the date range thumb width based on the window size relative to the total span 
      dateRangeSlider.style.setProperty('--thumb-width', `${thumb_width}px`);
      
    }
  };
};
